import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const ButtonContainer = styled("div", {
    shouldForwardProp: prop => prop !== "applyMarginCompensation",
})<{applyMarginCompensation?: boolean}>`
    @media (min-width: ${breakpoints.values.md}px) {
        ${({applyMarginCompensation}) => (applyMarginCompensation ? "margin-left: 0.5rem;" : "")}
    }
`

export const ImageContainer = styled("button")`
    cursor: pointer;
    display: flex;
    padding: 0.625rem;
    background-color: transparent;
    border: none;
    &:active {
        background-color: transparent;
        border: none;
    }
`

export const Img = styled("img")`
    display: flex;
    border-radius: 50%;
    width: 1.375rem;
    height: 1.375rem;
    background: ${({theme}) =>
        theme.uxfabric.components.appBar.brandBar.default.button.outlined.primary.enabled.borderColor};
    border: 0.0625rem solid
        ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.button.outlined.primary.enabled.borderColor};
    @media (min-width: ${breakpoints.values.md}px) {
        width: 1.5rem;
        height: 1.5rem;
    }
`
